<div class=" bg-surface">
	<main>
		<!--start the project-->
		<div id="main-wrapper" class=" flex p-5 xl:pr-0">
			<app-sibe-bar></app-sibe-bar>
			<div class=" w-full page-wrapper xl:px-6 px-0">

				<!-- Main Content -->
				<main class="h-full  max-w-full">
					<div class="container full-container p-0 flex flex-col gap-6">
						<app-profil-bar></app-profil-bar>
						<router-outlet></router-outlet>
						<app-footer></app-footer>
					</div>


				</main>
				<!-- Main Content End -->

			</div>
		</div>
		<!--end of project-->
	</main>
</div>